module.exports = __webpack_public_path__ + "static/media/LP6.d1869db6.svg";